module.exports = __webpack_public_path__ + "img/Alex_Bykov_photo.fe054c8f.png";